import { render } from "./ObjectivesListingTable.vue?vue&type=template&id=656e5455&scoped=true"
import script from "./ObjectivesListingTable.vue?vue&type=script&lang=js"
export * from "./ObjectivesListingTable.vue?vue&type=script&lang=js"

import "./ObjectivesListingTable.vue?vue&type=style&index=0&id=656e5455&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656e5455"]])

export default __exports__